/**
 * ZonaNav (IMPL-068 · 2026-07-16) — Barra de navegación coherente para las 4 zonas.
 *
 * Se renderiza dentro del header de cada zona (Captación / Prospección / Desarrollo / Admin)
 * y siempre muestra los 4 accesos + Volver al menú + Cerrar sesión. La zona activa se destaca.
 *
 * Cada acceso navega directamente a la URL correspondiente (usa las rutas globales de App.js).
 *
 * Prop:
 *   activa: "captacion" | "prospeccion" | "desarrollo" | "saas" | "admin"
 *   onLogout: función · disparada por el botón "Cerrar sesión"
 *   esAdmin: boolean · si false, oculta el botón de Administración
 *   onVolverMenu: opcional · si se pasa, sobreescribe el navigate('/admin')
 */
import React from "react";
import { Target, Sparkles, Compass, Settings, Home, ServerCog } from "lucide-react";

const ZONAS = [
  { key: "captacion",    href: "/admin/zona1",         icon: Target,   label: "Captación" },
  { key: "prospeccion",  href: "/admin/prospeccion",   icon: Sparkles, label: "Prospección" },
  { key: "desarrollo",   href: "/admin/clientes",      icon: Compass,  label: "Desarrollo" },
  { key: "saas",         href: "/admin/saas/inicio",    icon: ServerCog,label: "Operaciones SaaS" },
  { key: "admin",        href: "/admin/administracion", icon: Settings, label: "Admin" },
];

export default function ZonaNav({ activa, onLogout, esAdmin = true, onVolverMenu }) {
  const go = (href) => (e) => {
    e.preventDefault();
    window.history.pushState({}, "", href);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  const volverMenu = onVolverMenu || (() => {
    window.history.pushState({}, "", "/admin");
    window.dispatchEvent(new PopStateEvent("popstate"));
  });

  const zonasVisibles = esAdmin ? ZONAS : ZONAS.filter(z => z.key !== "admin");

  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid="zona-nav">
      <button
        onClick={volverMenu}
        title="Volver al menú principal"
        data-testid="zona-nav-home"
        className="p-1.5 rounded-lg bg-white/10 text-white/90 border border-white/20 hover:bg-white/20 flex items-center gap-1.5"
      >
        <Home className="w-4 h-4" />
      </button>
      <span className="text-white/30 text-xs">·</span>
      {zonasVisibles.map((z) => {
        const Icon = z.icon;
        const isActive = z.key === activa;
        return (
          <a
            key={z.key}
            href={z.href}
            onClick={go(z.href)}
            data-testid={`zona-nav-${z.key}`}
            className={`text-xs px-2.5 py-1.5 rounded-lg border flex items-center gap-1.5 transition ${
              isActive
                ? "bg-white text-slate-900 border-white font-bold shadow-sm"
                : "bg-white/10 text-white/85 border-white/20 hover:bg-white/20"
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            <span className="hidden md:inline">{z.label}</span>
          </a>
        );
      })}
      {onLogout && (
        <>
          <span className="text-white/30 text-xs ml-1">·</span>
<button
            onClick={() => window.dispatchEvent(new Event('abrir-cambiar-password'))}
            data-testid="zona-nav-cambiar-password"
            className="text-xs px-3 py-1.5 rounded-lg bg-white/10 text-white border border-white/20 hover:bg-white/20"
          >
            Cambiar contraseña
          </button>
          <button
            onClick={onLogout}
            data-testid="zona-nav-logout"
            className="text-xs px-3 py-1.5 rounded-lg bg-white/10 text-white border border-white/20 hover:bg-white/20"
          >
            Cerrar sesión
          </button>
        </>
      )}
    </div>
  );
}
